import { StepNav } from 'slab'

import { type EnrollmentEventLike, isEnrollmentEventQle, isEnrollmentEventRenewal, shouldSkipQleDocumentUpload } from '../utils'
import { getStepsFromData, type StepConfig } from './Navigation'
import { type Step } from '../types'

const maybeAddQLEDocumentUpload = (
  enrollmentEvent?: EnrollmentEventLike | null
): StepConfig[] => {
  if (shouldSkipQleDocumentUpload(enrollmentEvent)) {
    return []
  }
  return [{
    stepName: 'qle_document_upload',
    stepLabel: 'Document upload',
  }]
}

export function StubbedOutOnboardingSideBar ({
  enrollmentEvent,
  newQleEnabled,
  completed = true,
  activeStep = 'last',
}: {
  enrollmentEvent?: EnrollmentEventLike;
  newQleEnabled?: boolean | null;
  completed?: boolean;
  activeStep?: 'first' | 'last';
}) {
  const isRenewalEvent = isEnrollmentEventRenewal(enrollmentEvent)
  // For QLE, we need both the enrollment event type AND the feature flag to be enabled
  const isQleEvent = isEnrollmentEventQle(enrollmentEvent) && !!newQleEnabled

  let steps: Array<StepConfig> = []
  if (isRenewalEvent) {
    steps = [
      { stepName: 'renewal_confirm_info' as Step, stepLabel: 'Personal details' },
      { stepName: 'renewal_show_summary' as Step, stepLabel: 'Budget and plan changes' },
      { stepName: 'medical_plan' as Step, stepLabel: 'Your insurance' },
      { stepName: 'renewal_confirm_enrollment' as Step, stepLabel: 'Confirm and enroll' },
    ]
  } else if (isQleEvent) {
    steps = [
      { stepName: 'qle_details' as Step, stepLabel: 'Qualifying life event details' },
      { stepName: 'renewal_confirm_info' as Step, stepLabel: 'Dependent changes' },
      { stepName: 'renewal_show_summary' as Step, stepLabel: 'Budget and plan changes' },
      { stepName: 'medical_plan' as Step, stepLabel: 'Your insurance' },
      ...maybeAddQLEDocumentUpload(enrollmentEvent),
      { stepName: 'renewal_confirm_enrollment' as Step, stepLabel: 'Confirm and enroll' },
    ]
  } else {
    steps = getStepsFromData(null).filter(Boolean) as Array<StepConfig>
  }

  const finalStepName = isRenewalEvent || isQleEvent
    ? 'renewal_confirm_enrollment'
    : 'finalize_enrollment'

  const activeStepName = activeStep === 'first' && steps.length > 0
    ? steps[0].stepName
    : finalStepName

  return (
    <StepNav>
      {steps.map(({ stepName, stepLabel }, idx) => (
        <StepNav.Step
          key={stepName as string}
          active={stepName === activeStepName}
          available={false}
          complete={completed ? idx !== steps.length - 1 : false}
          name={stepLabel}
        />
      ))}
    </StepNav>
  )
}
